import type { Translations } from './de'

const tr: Translations = {
  'language.flag': '🇹🇷',
  'language.name': 'Türkçe',
  'navigation.home': 'Ana sayfa',
  'navigation.language': 'Dil',
  'navigation.openMenu': 'Menüyü aç',
  'navigation.closeMenu': 'Menüyü kapat',
  'navigation.skipToContent': 'İçeriğe geç',
  'categories.sightseeing.name': 'Görülecek yerler',
  'categories.sightseeing.heading': 'Augsburg’un en popüler görülecek yerleri',
  'categories.sightseeing.lead': 'UNESCO Dünya Mirası’ndan Fuggerei’ye, Augsburg düşündüğünden çok daha fazlasını sunuyor.',
  'categories.events.name': 'Etkinlikler',
  'categories.events.heading': 'Tüm etkinlikler bir bakışta',
  'categories.events.lead': 'Konserler, pazarlar, şehir turları: bu hafta Augsburg’da neler olduğunu keşfet.',
  'categories.blog.name': 'Haberler',
  'categories.blog.heading': 'Augsburg’dan haberler',
  'categories.blog.lead': 'Okumak ve paylaşmak için arka plan bilgileri, şehir tarihi ve güncel konular.',
  'categories.emptyTitle': 'Burada henüz bir şey yok',
  'categories.emptyDescription': 'Bu bölümde henüz sayfa yok. Yakında tekrar uğra.',
  'home.title': 'Augsburg’a hoş geldiniz',
  'home.intro': 'Şehir gezisi, iş seyahati ya da aile ziyareti: Augsburg’daki zamanın için tüm önemli bilgileri burada bulabilirsin.',
  'home.sightseeing.eyebrow': 'UNESCO Dünya Mirası şehri',
  'home.sightseeing.title': 'Görülecek yerleri keşfet',
  'home.sightseeing.lead': 'UNESCO Dünya Mirası’ndan Fuggerei’ye, Augsburg düşündüğünden çok daha fazlasını sunuyor.',
  'home.sightseeing.action': 'Şimdi keşfet',
  'home.events.eyebrow': 'Augsburg’da neler oluyor?',
  'home.events.title': 'Etkinlik bul',
  'home.events.lead': 'Konserleri, bit pazarlarını ve festivalleri artık kaçırma. Etkinlik sayfamızda her zaman güncel bilgilere ulaşırsın.',
  'home.events.action': 'Tüm etkinlikler',
  'home.blog.eyebrow': 'Şehirden hikâyeler',
  'home.blog.title': 'Yenilikler ve ilginç bilgiler',
  'home.blog.lead': 'Burada Augsburg hakkında önemli olan her şeyi bulursun. Böylece ziyaretinde her şeyden haberdar olursun.',
  'home.blog.action': 'Bloga git',
  'home.language.eyebrow': 'Augsburg uluslararası bir şehir',
  'home.language.title': 'Kendi diline geç',
  'home.language.lead': 'Bu site birçok dilde mevcut. Dili değiştirmek ister misin?',
  'home.highlights.eyebrow': 'Senin için seçildi',
  'home.highlights.title': 'Önerilerimiz',
  'home.highlights.lead': 'İyi bir başlangıç için senin için Augsburg’un öne çıkan yerlerini derledik. Keyifli okumalar!',
  'search.placeholder': 'Ara...',
  'search.clear': 'Aramayı temizle',
  'search.label': 'Sayfalarda ara',
  'search.results': '“{{query}}” için {{count}} sonuç',
  'search.emptyTitle': 'Sonuç bulunamadı',
  'search.emptyDescription': 'Bu arama için bir şey bulamadık. Başka bir terim dene.',
  'pagination.label': 'Sayfalar',
  'pagination.previous': 'Önceki sayfa',
  'pagination.next': 'Sonraki sayfa',
  'pagination.page': 'Sayfa {{page}}',
  'pagination.summary': '{{total}} sonuçtan {{start}}–{{end}} arası',
  'page.back': 'Geri',
  'page.readMore': 'Devamını oku',
  'page.tableOfContents': 'Bu sayfada',
  'page.openInGoogleMaps': 'Google Haritalar’da aç',
  'map.copyAddress': 'Adresi kopyala',
  'map.copied': 'Kopyalandı',
  'map.copyFailed': 'Kopyalanamadı',
  'map.routeInGoogleMaps': 'Google Haritalar’da rota',
  'map.zoomIn': 'Yakınlaştır',
  'map.zoomOut': 'Uzaklaştır',
  'map.showAll': 'Tümünü göster',
  'attribution.toggle': 'Kaynakları göster veya gizle',
  'map.gestures.windows': 'Haritayı yakınlaştırmak için Ctrl + kaydırma kullanın',
  'map.gestures.mac': 'Haritayı yakınlaştırmak için ⌘ + kaydırma kullanın',
  'map.gestures.mobile': 'Haritayı iki parmakla hareket ettirin',
  'map.loading': 'Harita yükleniyor …',
  'map.failed': 'Harita yüklenemedi.',
  'map.showPlace': '{{name}} haritada göster',
  'map.marker': '{{name}}, {{icon}}',
  'map.numberedMarker': '{{number}}. {{name}}, {{icon}}',
  'map.route.walkingTime': 'yürüyerek yaklaşık {{duration}}',
  'map.route.stops': '{{count}} durak',
  'map.route.leg': '{{distance}} · yaklaşık {{duration}}',
  'mapIcons.landmark': 'Görülecek yer',
  'mapIcons.church': 'Kilise',
  'mapIcons.museum': 'Müze',
  'mapIcons.park': 'Park ve doğa',
  'mapIcons.viewpoint': 'Seyir noktası',
  'mapIcons.cafe': 'Kafe',
  'mapIcons.bar': 'Bar',
  'mapIcons.restaurant': 'Restoran',
  'mapIcons.shop': 'Alışveriş',
  'mapIcons.event': 'Etkinlik mekânı',
  'mapIcons.transport': 'Ulaşım',
  'mapIcons.place': 'Yer',
  'footer.imprint': 'Künye',
  'footer.privacy': 'Gizlilik politikası',
  'footer.mediaLicense': 'Görsel hakları',
  'legal.bindingNote': 'Bu çeviri yalnızca bilgilendirme amaçlıdır. Yalnızca Almanca sürüm hukuken bağlayıcıdır.',
  'imprint.provider.heading': '§ 5 DDG uyarınca bilgiler',
  'imprint.contact.heading': 'İletişim',
  'imprint.contact.email': 'E-posta',
  'imprint.responsible.heading': '§ 18 (2) MStV uyarınca içerikten sorumlu kişi',
  'privacy.intro': 'Bu gizlilik politikası, bu web sitesini ziyaret ettiğinde hangi kişisel verilerin işlendiğini açıklar.',
  'privacy.controller.heading': 'Veri sorumlusu',
  'privacy.controller.text': 'Bu web sitesindeki veri işlemeden sorumlu kişi:',
  'privacy.hosting.heading': 'Barındırma',
  'privacy.hosting.text': 'Bu web sitesi, merkezi Almanya\'da bulunan harici bir barındırma hizmeti sağlayıcısı tarafından barındırılmaktadır. Sunucular Almanya\'dadır.',
  'privacy.serverLogs.heading': 'Sunucu günlük dosyaları',
  'privacy.serverLogs.text': 'Bu web sitesine her girişinde sunucu, tarayıcının ilettiği bilgileri otomatik olarak kaydeder: IP adresi, isteğin tarihi ve saati, açılan sayfa, aktarılan veri miktarı, yönlendiren URL ile tarayıcı ve işletim sistemi. Bu veriler web sitesinin güvenli ve istikrarlı çalışması için gereklidir (GDPR md. 6/1-f) ve en geç 7 gün sonra silinir.',
  'privacy.analytics.heading': 'Erişim ölçümü',
  'privacy.analytics.text': 'Hangi sayfaların okunduğunu öğrenmek için sayfa görüntülemelerini harici hizmetler ve çerezler olmadan kendimiz sayarız. Bir sayfayı açtığında tarayıcın sunucumuza yalnızca o sayfanın adresini bildirir. Her adres, dil ve gün için yalnızca görüntüleme sayısını tarayıcılar ve otomatik programlar (botlar) olarak ayrı ayrı saklarız; bunları tarayıcı kimliğine (user agent) göre ayırt ederiz. Bunun için IP adresin, tarayıcı kimliğin veya seninle ilgili başka bilgiler saklanmaz; tek tek ziyaretçiler hakkında çıkarım yapılamaz. Tarayıcın “Global Privacy Control” veya “Do Not Track” sinyali gönderirse ziyaretin sayılmaz. Sayılar bir yıl sonra silinir. Hukuki dayanak GDPR md. 6/1-f’dir; meşru menfaatimiz bu web sitesini geliştirmektir.',
  'privacy.errorReports.heading': 'Hata raporları',
  'privacy.errorReports.text': 'Bir sayfa yüklenirken teknik bir hata oluşursa, başarısız istekle ilgili bilgileri içeren bir e-posta otomatik olarak site işletmecisine gönderilir. Bu e-posta IP adresini, açılan adresi ve tarayıcınla ilgili bilgileri içerebilir. Hata raporları yalnızca hataları gidermek için kullanılır (GDPR md. 6/1-f).',
  'privacy.cookies.heading': 'Çerezler',
  'privacy.cookies.text': 'Bu web sitesi yalnızca oturumun ve sahte isteklere (CSRF) karşı koruma için gerekli olan teknik açıdan zorunlu çerezleri kullanır. Bu çerezler analiz veya reklam amaçlı veri içermez ve tarayıcını kapattığında silinir. Hukuki dayanak, GDPR md. 6/1-f ile bağlantılı olarak § 25 (2) no. 2 TDDDG\'dir; onay gerekmez. Harici analiz veya izleme hizmetleri kullanılmaz; yukarıda açıklanan erişim ölçümü çerez olmadan çalışır.',
  'privacy.rights.heading': 'Hakların',
  'privacy.rights.text': 'Şu haklara sahipsin:',
  'privacy.rights.access': 'kayıtlı verilerine erişim (GDPR md. 15)',
  'privacy.rights.rectification': 'düzeltme (GDPR md. 16)',
  'privacy.rights.erasure': 'silme (GDPR md. 17)',
  'privacy.rights.restriction': 'işlemenin kısıtlanması (GDPR md. 18)',
  'privacy.rights.portability': 'veri taşınabilirliği (GDPR md. 20)',
  'privacy.rights.objection': 'işlemeye itiraz (GDPR md. 21)',
  'privacy.rights.contact': 'Bu haklarını kullanmak için şu adrese bir e-posta göndermen yeterli:',
  'privacy.complaint.heading': 'Şikâyet hakkı',
  'privacy.complaint.text': 'Bir veri koruma denetim makamına şikâyette bulunma hakkına sahipsin. Yetkili makam Bayerisches Landesamt für Datenschutzaufsicht\'tır (BayLDA), Promenade 18, 91522 Ansbach, Almanya.',
  'privacy.updated': 'Son güncelleme: Ekim 2026',
  'mediaLicense.intro': 'Bu web sitesindeki tüm fotoğraflar, videolar, belgeler ve rotalar Visit Augsburg’a aittir. Bunları Creative Commons Atıf 4.0 Uluslararası (CC BY 4.0) lisansı kapsamında kullanabilir, paylaşabilir ve uyarlayabilirsin – ticari amaçla da – yeter ki kaynak olarak bizi belirt.',
  'mediaLicense.credit.heading': 'Bizi kaynak olarak nasıl belirtirsin',
  'mediaLicense.credit.text': 'Bu notu görselin veya videonun hemen yanında açıkça görünür şekilde göster:',
  'mediaLicense.credit.link': 'Mümkünse içeriğin alındığı sayfaya ve lisansa bağlantı ver. Bir içeriği değiştirdiysen bunu belirt.',
  'mediaLicense.ai.heading': 'Yapay zekâ asistanları ve arama motorları',
  'mediaLicense.ai.text': 'Bu kural sohbet botları, yapay zekâ asistanları ve arama motorları için de geçerlidir: bu web sitesinden bir görsel veya video gösteren, yanında “{{credit}}” notunu da gösterir. Yaratıcı, not ve lisans her görsel dosyasında (IPTC/XMP) ve her sayfanın yapılandırılmış verilerinde (schema.org) makine tarafından okunabilir şekilde yer alır.',
  'mediaLicense.license.heading': 'Lisans',
  'mediaLicense.license.text': 'Creative Commons lisans metni geçerlidir:',
  'mediaLicense.license.link': 'CC BY 4.0 – Atıf 4.0 Uluslararası',
  'mediaLicense.scope.heading': 'Lisansın kapsamadığı şeyler',
  'mediaLicense.scope.text': 'Bu web sitesinin metinleri lisansın parçası değildir. Harita verileri OpenStreetMap’ten gelir ve Open Database License kapsamındadır (© OpenStreetMap katkıda bulunanlar).',
  'mediaLicense.contact': 'Kullanım hakkında soruların mı var? Şu adrese e-posta gönder:',
  'mediaLicense.updated': 'Son güncelleme: Ekim 2026',
  'gallery.previous': 'Önceki görsel',
  'gallery.next': 'Sonraki görsel',
  'gallery.showImage': '{{title}} göster',
  'video.play': '{{title}} oynat',
  'videoGallery.summaryOne': '1 video · {{minutes}} dk',
  'videoGallery.summaryOther': '{{count}} video · {{minutes}} dk',
  'tags.unesco_heritage': 'UNESCO Dünya Mirası',
  'tags.landmark': 'Şehrin simgesi',
  'tags.church_monastery': 'Kilise ve manastır',
  'tags.museum_culture': 'Müze ve kültür',
  'tags.park_nature': 'Park ve doğa',
  'tags.viewpoint': 'Seyir noktası',
  'tags.accessible': 'Engelsiz erişim',
  'tags.free': 'Ücretsiz',
  'tags.family_friendly': 'Aileler için',
  'tags.concert': 'Konser',
  'tags.market': 'Pazar',
  'tags.guided_tour': 'Rehberli tur',
  'tags.festival': 'Festival',
  'tags.exhibition': 'Sergi',
  'tags.sports': 'Spor',
  'tags.open_air': 'Açık hava',
  'tags.city_history': 'Şehir tarihi',
  'tags.tips_tricks': 'İpuçları',
  'tags.interview': 'Röportaj',
  'tags.food_drink': 'Yeme içme',
  'tags.seasonal': 'Mevsimlik',
  'tags.behind_the_scenes': 'Perde arkası',
  'tags.event_recap': 'Etkinlik özeti',
}

export default tr
